<template>
  <div>
    <div class="level">
      <div class="level-left">
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="billings.data"
      :search="search"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="billings.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
      :placeholder="'Search by Billing I.D, D.R #, S.I # and Client'"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column class="table-column-content-is-small" label="Ref. #">
          {{ item.row.refNo }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="S.I #">
          {{ item.row.siNum }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="S.I Date">
          {{ item.row.siDate }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="D.R #">
          {{ item.row.drNum }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="D.R Date">
          {{ item.row.drDate }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Client P.O"
        >
          {{ item.row.clientPo }} - <i>{{ item.row.client }}</i>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Selling">
          {{ item.row.selling | formatNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Paid">
          {{ item.row.paid | formatNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Balance">
          {{ item.row.balance | formatNumber }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Date Created"
        >
          {{ item.row.dateCreated }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <router-link
            class="button is-small is-warning"
            :to="{
              name: 'Edit Billing',
              params: { billingId: item.row.billingId }
            }"
            >View</router-link
          >
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import Delete from "./Delete.vue";
import numeral from "numeral";

Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

export default {
  components: {
    TablePagination,
    Delete
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("billing", {
      billings: state => state.billings,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: ""
  }),
  created() {
    this.navFromPageParam();
  },
  methods: {
    ...mapActions("billing", ["getPaginatedData", "openDeleteModal"]),
    navFromPageParam() {
      this.$router.push({
        name: "List of Billing",
        params: {
          page: parseInt(!this.page ? 1 : this.page),
          pageSize: parseInt(!this.perPage ? 10 : this.perPage),
          searchQuery: !this.search ? null : this.search
        }
      });

      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      });
    },
    deleteData(id) {
      this.openDeleteModal({
        showDeleteModal: true,
        delivery: {
          deliveryId: id
        }
      });
    },
    refreshTable() {
      this.default();
    },
    default() {
      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      });
    }
  },
  watch: {
    perPage(val) {
      this.navFromPageParam();
    },
    page(val) {
      this.navFromPageParam();
    },
    search(val) {
      this.navFromPageParam();
    }
  }
};
</script>
